import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { RevenueOperationsScorecard } from '../types';
import DynamicSection from './DynamicSection';

interface ScorecardContentProps {
  loading: boolean;
  error: string;
  data: RevenueOperationsScorecard | null;
}

const ScorecardContent: React.FC<ScorecardContentProps> = ({ loading, error, data }) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ mb: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ mb: 3 }}>
        <Alert severity="info">No scorecard data available. Please select a dealer.</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: '1000px' }}>
      {data.sections.map((section, index) => (
        <DynamicSection key={index} section={section} />
      ))}
    </Box>
  );
};

export default ScorecardContent;

